import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';

@Component({
    selector: 'input-number',
    templateUrl: './input.number.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputNumber),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputNumber implements OnInit, OnChanges, ControlValueAccessor {

    value: number;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (string) => string; 

    error: string;

    @Input()
    valueMin: number;

    @Input()
    valueMax: number;

    @Input()
    valueStep: number = 1;

    @Input()
    tickStep: number = 1;

    @Input()
    ticks: number[];

    @Input()
    labels: string[];

    @Input()
    positions: number[];

    mode: 'input' | 'steps' | 'slider' = 'input';

    // control: FormControl;

    ngOnInit() {
      this.getMode();
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
      this.getMode();
    }

    getMode() {
      this.mode = 'input';
      if (this.tickStep && this.valueMin != undefined && this.valueMin != null && this.valueMax != undefined && this.valueMax != null) {
        if ((this.valueMax - this.valueMin) / this.tickStep <= 12) {
          this.mode = 'slider';
        }
      }
      if (this.ticks && this.labels && this.positions) {
        if (this.ticks.length == this.labels.length && this.ticks.length == this.positions.length) {
          this.mode = 'steps';
        }
      }
    }

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeValue(event: number) {
      this.value = event;
      this.propagateChange(event);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      // this.error = null;
      // if (this.required) {
      //   this.error = 'Value is required';
      // }
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        if (value != this.value) {
          this.changeValue(value);
        }
        this.value = value;
      // }
    }

    propagateChange = (_: number) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}